import * as Actions from "./actions";
import clearAuth from "../../../../utils/clearAuth";
import ApiService from "../../../../utils/apiService";
import { SUCCESS, NOTIF_ERROR, NOTIF_SUCCESS } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";


const loginUser = (username, password) => (dispatch) => {

    let payload = { username, password }

    return ApiService.token(payload)
        .then((response) => {
            if ("ROLE_ADMIN" === response.data.authorities[0].authority || "ROLE_SUPERADMIN" === response.data.authorities[0].authority) {
                dispatch(Actions.setUserAuth(response.data, true));
                return response.data;
            }
            else {
                return undefined;
            }
        })
        .catch((error) => {
            console.log(error);
        })
}

const loginAdmin = (username, password) => (dispatch) => {
    let params = new FormData();
    params.append("username", username);
    params.append("password", password);

    return ApiService.post("/login/admin", params)
        .then((response) => {
            if (null !== response.data.data) {
                dispatch(Actions.setUserAuth(response.data.data.access_token, true));
            }
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        })
}

const logoutUser = (tokenId) => (dispatch) => {
    return ApiService.rawDelete(`/logout/${tokenId}`)
        .then((response) => {
            if (SUCCESS === response.data.status) {
                SideNotification(NOTIF_SUCCESS, "Logout successful")
                dispatch(Actions.setUserAuth([], false));
                clearAuth();
            } else {
                SideNotification(NOTIF_ERROR, "Logout failed")
            }

            return response.data;
        })
        .catch(()=>{
            SideNotification(NOTIF_ERROR, "Logout failed")
        })

};

const loginStore = (username, password) => (dispatch) => {
    let params = new FormData();
    params.append("username", username);
    params.append("password", password);

    return ApiService.post("/login/store", params)
        .then((response) => {
            if (null !== response.data.data) {
                dispatch(Actions.setStoreAuth(response.data.data, true));
            }
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        })
}

const resetPassword = (resetPasswordModel) => () => {
    return ApiService.post("/user/resetPassword", resetPasswordModel)
        .then((response) => {
            return response.data
        })
}

const checkRequestCount = (resetPasswordModel) => () => {
    return ApiService.post("/user/checkRequestCount", resetPasswordModel)
        .then((response) => {
            return response.data
        })
}

const logoutStore = () => (dispatch) => {
    dispatch(Actions.setStoreAuth([], false));
    clearAuth();
};

export {
    loginUser,
    logoutUser,
    loginStore,
    logoutStore,
    resetPassword,
    checkRequestCount,
    loginAdmin
};
